import { useState, useCallback } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import DeleteConversationModal from "../components/DeleteConversationModal";
import ENDPOINTS from "../api/endpoint";
import { showSuccessToast } from "../components/Toast";

export default function MainLayout({ children, theme, setTheme }) {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [conversationToDelete, setConversationToDelete] = useState(null);

  const handleRequestDeleteConversation = useCallback((conversation) => {
    setConversationToDelete(conversation);
    setIsDeleteModalOpen(true);
  }, []);

  const handleCloseDeleteModal = useCallback(() => {
    setIsDeleteModalOpen(false);
    setConversationToDelete(null);
  }, []);

  const handleConfirmDelete = useCallback(async () => {
    if (!conversationToDelete) return;

    const { id: conversationId, company_id, user_id } = conversationToDelete;
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const token = user?.access_token;

    if (!token) {
      console.error("Missing token ❌");
      return;
    }

    try {
      const res = await fetch(
        ENDPOINTS.DELETE_CONVERSATION(company_id, conversationId, user_id),
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!res.ok) {
        const error = await res.json();
        console.error("Failed to delete conversation ❌", error);
        return;
      }

      console.log("Conversation deleted ✅", conversationId);
      showSuccessToast("Conversation deleted ✅");

      // ✅ Remove from Sidebar list
      if (window.removeConversationFromSidebar) {
        window.removeConversationFromSidebar(conversationId);
      }

      // ✅ Reload page if the deleted conversation is the currently active one
      const activeConversationId = localStorage.getItem("conversation_id");
      if (activeConversationId === conversationId) {
        window.location.reload();
      }
    } catch (err) {
      console.error("Error deleting conversation:", err);
    } finally {
      setIsDeleteModalOpen(false);
      setConversationToDelete(null);
    }
  }, [conversationToDelete]);

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <div className="h-full overflow-x-hidden no-scrollbar overflow-y-auto">
        <Sidebar
          onRequestDeleteConversation={handleRequestDeleteConversation}
        />
      </div>

      {/* Main Content */}
      <div className="flex flex-col flex-1 h-full">
        <Navbar
          theme={theme}
          setTheme={setTheme}
          onRequestDeleteConversation={handleRequestDeleteConversation}
        />
        <main className="flex-1 bg-bg-light dark:bg-bg-dark transition-colors duration-300 overflow-y-auto">
          {children}
        </main>
      </div>

      <DeleteConversationModal
        isOpen={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDelete}
      />
    </div>
  );
}
